import { render, staticRenderFns } from "./ReceiveOrder.vue?vue&type=template&id=376ed312&scoped=true&"
import script from "./ReceiveOrder.vue?vue&type=script&lang=js&"
export * from "./ReceiveOrder.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveOrder.vue?vue&type=style&index=0&id=376ed312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376ed312",
  null
  
)

export default component.exports